import * as Blockly from 'blockly';

/**
 * SPblock Blockly theme — 2015 flat chrome to match the design system:
 * warm-grey workspace, flat white toolbox, material-blue selection accents.
 */
export const ebsTheme = Blockly.Theme.defineTheme('spblock-2015', {
  name: 'spblock-2015',
  base: Blockly.Themes.Classic,
  componentStyles: {
    workspaceBackgroundColour: '#F7FBFE',
    toolboxBackgroundColour: '#FFFFFF',
    toolboxForegroundColour: '#1e293b',
    flyoutBackgroundColour: '#FFFFFF',
    flyoutForegroundColour: '#5b6b7f',
    flyoutOpacity: 1,
    scrollbarColour: '#a9cfe8',
    scrollbarOpacity: 0.6,
    insertionMarkerColour: '#89CFF0',
    insertionMarkerOpacity: 0.55,
    cursorColour: '#89CFF0',
    selectedGlowColour: '#89CFF0',
    replacementGlowColour: '#89CFF0',
  },
  fontStyle: {
    family: '-apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    weight: '500',
    size: 12,
  },
});
